// extracted by mini-css-extract-plugin
export default {"desc":"ConstituentDocuments_desc__010z0","item":"ConstituentDocuments_item__7ksJZ"};